import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { flushIfNeeded2jf5glmfh5e3h as flushIfNeeded } from './ByteWriteChannel.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { startCoroutineCancellable18shtfwdieib as startCoroutineCancellable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/intrinsics/Cancellable.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  cancel1xim2hrvjmwpn as cancel,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_NO_CALLBACK() {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return NO_CALLBACK;
}
var NO_CALLBACK;
function *writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? value.length : endIndex;
  _this__u8e3s4.t4j().p4g(value, startIndex, endIndex);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
var WriterJobClass;
function WriterJob() {
  if (WriterJobClass === VOID) {
    class $ {
      constructor(channel, job) {
        this.b4l_1 = channel;
        this.c4l_1 = job;
      }
      j12() {
        return this.c4l_1;
      }
    }
    initMetadataForClass($, 'WriterJob');
    WriterJobClass = $;
  }
  return WriterJobClass;
}
function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  autoFlush = autoFlush === VOID ? false : autoFlush;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return writer_0(_this__u8e3s4, coroutineContext, new (ByteChannel())(), block);
}
var WriterScopeClass;
function WriterScope() {
  if (WriterScopeClass === VOID) {
    class $ {
      constructor(channel, coroutineContext) {
        this.d4l_1 = channel;
        this.e4l_1 = coroutineContext;
      }
      dw() {
        return this.e4l_1;
      }
    }
    initMetadataForClass($, 'WriterScope', VOID, VOID, [CoroutineScope()]);
    WriterScopeClass = $;
  }
  return WriterScopeClass;
}
function invokeOnCompletion(_this__u8e3s4, block) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return _this__u8e3s4.j12().gx(block);
}
function close(_this__u8e3s4, cause) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  if (cause == null) {
    fireAndForget(ByteWriteChannel$flushAndClose$ref_0(_this__u8e3s4));
  } else {
    _this__u8e3s4.i4k(cause);
  }
}
function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  // Inline function 'kotlin.apply' call
  var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda_0(block, channel));
  this_0.gx((it) => {
    var tmp;
    if (!(it == null) && !channel.u4j()) {
      channel.i4k(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var job = this_0;
  return new (WriterJob())(channel, job);
}
function fireAndForget(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
}
function *writeByte(_this__u8e3s4, value, $completion) {
  _this__u8e3s4.t4j().y4g(value);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
var NO_CALLBACK$1Class;
function NO_CALLBACK$1() {
  if (NO_CALLBACK$1Class === VOID) {
    class $ {
      constructor() {
        this.f4l_1 = EmptyCoroutineContext_instance;
      }
      mc() {
        return this.f4l_1;
      }
      nc(result) {
        return Unit_instance;
      }
      oc(result) {
        return this.nc(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    NO_CALLBACK$1Class = $;
  }
  return NO_CALLBACK$1Class;
}
var ByteWriteChannel$flushAndClose$refClass;
function ByteWriteChannel$flushAndClose$ref() {
  if (ByteWriteChannel$flushAndClose$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.g4l_1 = p0;
      }
      *h4l($completion) {
        return yield* this.g4l_1.h4k($completion);
      }
      kd($completion) {
        return this.h4l($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    ByteWriteChannel$flushAndClose$refClass = $;
  }
  return ByteWriteChannel$flushAndClose$refClass;
}
function ByteWriteChannel$flushAndClose$ref_0(p0) {
  var i = new (ByteWriteChannel$flushAndClose$ref())(p0);
  var l = ($completion) => i.h4l($completion);
  l.callableName = 'flushAndClose';
  l.$arity = 0;
  return l;
}
var writer$slambdaClass;
function writer$slambda() {
  if (writer$slambdaClass === VOID) {
    class $ {
      constructor($block, $channel) {
        this.i4l_1 = $block;
        this.j4l_1 = $channel;
      }
      *b1g($this$launch, $completion) {
        var nested = Job(get_job($this$launch.dw()));
        try {
          yield* this.i4l_1(new (WriterScope())(this.j4l_1, $this$launch.dw().rm(nested)), $completion);
          nested.v12();
          if (get_job($this$launch.dw()).ax()) {
            this.j4l_1.i4k(get_job($this$launch.dw()).dx());
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            cancel(nested, 'Exception thrown while writing to channel', cause);
            this.j4l_1.i4k(cause);
          } else {
            throw $p;
          }
        }
        finally {
          yield* nested.kx($completion);
          // Inline function 'kotlin.runCatching' call
          var tmp;
          try {
            yield* this.j4l_1.h4k($completion);
            // Inline function 'kotlin.Companion.success' call
            tmp = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
              var e = $p;
              // Inline function 'kotlin.Companion.failure' call
              tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
            } else {
              throw $p;
            }
            tmp = tmp_0;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.b1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    writer$slambdaClass = $;
  }
  return writer$slambdaClass;
}
function writer$slambda_0($block, $channel) {
  var i = new (writer$slambda())($block, $channel);
  var l = ($this$launch, $completion) => i.b1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
  if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
    properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
    NO_CALLBACK = new (NO_CALLBACK$1())();
  }
}
//region block: exports
export {
  writeByte as writeByte1opghdrkskh5z,
  writeFully as writeFully1yd4favg5iwxl,
  WriterScope as WriterScope3b0bo1enaee6b,
  close as close3semq7pafb42g,
  invokeOnCompletion as invokeOnCompletion1ziuxzoag0iwj,
  writer as writer1eia5its2a1fh,
};
//endregion

//# sourceMappingURL=ByteWriteChannelOperations.mjs.map
